import './button.css'
import React from 'react'

const Button = ({ onClick, disabled, className, text}) => {

  return <button onClick={onClick} disabled={disabled} className={className} ><b>{text}</b></button>
}

export default Button